import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

const SwalModal = withReactContent(Swal)

const question = (
  title,
  resultSuccess,
  resultCancel,
  text = '',
  icon = 'success',
  showCancelButton = true
) => {
  SwalModal.fire({
    title,
    text,
    icon,
    color: '#2E7423',
    showCancelButton,
    confirmButtonColor: '#2E7423',
    cancelButtonColor: '#F56767',
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      resultSuccess()
    } else if (resultCancel) {
      resultCancel()
    }
  })
}

const questionWithInput = (
  title,
  resultSuccess,
  text = '',
  inputLabel = 'Motivo'
) => {
  SwalModal.fire({
    title,
    text,
    icon: 'question',
    color: '#2E7423',
    input: 'textarea',
    inputLabel,
    inputPlaceholder: 'Ingrese el motivo',
    inputAttributes: {
      maxlength: 500
    },
    showCancelButton: true,
    confirmButtonColor: '#2E7423',
    cancelButtonColor: '#F56767',
    confirmButtonText: 'Archivar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
    inputValidator: (value) => {
      if (!value?.trim()) {
        return 'Debe ingresar un motivo'
      }
      return null
    }
  }).then((result) => {
    if (result.isConfirmed) {
      resultSuccess(result.value.trim())
    }
  })
}

const basic = (title, textButton, text = '', icon = 'success') => {
  SwalModal.fire({
    title,
    text,
    icon,
    color: '#2E7423',
    showCancelButton: false,
    confirmButtonColor: icon !== 'error' ? '#2E7423' : '#F56767',
    confirmButtonText: textButton,
    reverseButtons: true
  })
}

const warning = (title, textButton, funt, text = '', icon = 'warning') => {
  SwalModal.fire({
    title,
    text,
    icon,
    color: '#2E7423',
    showCancelButton: false,
    confirmButtonColor: icon !== 'error' ? '#FF9633' : '#F56767',
    confirmButtonText: textButton,
    reverseButtons: true
  }).then(() => {
    funt()
  })
}
export default { question, questionWithInput, basic, warning }
